<template>
  <div class="lv lv-success">
    <div class="lv-shell lv-success__inner">
      <div class="lv-success__card">
        <h1 class="lv-success__title">Выезд забронирован</h1>
        <div class="lv-success__text">
          <p>По подтверждению сообщим. Статус заявки можно смотреть в личном кабинете.</p>
          <p v-if="!isSubscribed" class="lv-success__telegram">
            Не забудьте подписаться на
            <button
                v-if="botLink === '#'"
                type="button"
                class="lv-success__telegram-link"
                :disabled="isLoading"
                @click="handleGenerateCode"
            >уведомления в Telegram</button>
            <a
                v-else
                :href="botLink"
                target="_blank"
                rel="noopener noreferrer"
                class="lv-success__telegram-link"
            >уведомления в Telegram</a>.
          </p>
          <p v-if="errorMessage" class="lv-success__error lv-error" role="alert">{{ errorMessage }}</p>
          <p>Время заполнить карту питомца — так врач сможет подготовиться заранее, а вы будете получать рекомендации с учётом особенностей вашего любимца.</p>
        </div>
        <div class="lv-success__actions">
          <NuxtLink to="/profile/" class="lv-btn lv-btn--accent lv-success__cta">Заполнить карту питомца</NuxtLink>
          <NuxtLink to="/profile/history/" class="lv-btn lv-btn--ghost lv-success__cta">Перейти в личный кабинет</NuxtLink>
        </div>
        <AppPromo />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const {
  isLoading,
  isSubscribed,
  botLink,
  errorMessage,
  handleGenerateCode,
} = useTelegramNotifications()

useHead({
  title: 'Выезд забронирован — Vetsy',
  meta: [{name: 'robots', content: 'noindex, nofollow'}],
});
</script>

<style lang="scss">
@use '~/assets/css/landing-visit.scss';
</style>

<style scoped lang="scss">
.lv-success {
  &__inner {
    padding-top: 48px;
    padding-bottom: 64px;
  }

  &__card {
    max-width: 640px;
    background: var(--lv-surface-card);
    border-radius: var(--lv-radius-24);
    box-shadow: var(--lv-shadow-1);
    padding: clamp(20px, 3vw, 32px);
  }

  &__title {
    margin: 0 0 16px;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
    font-size: 16px;
    color: var(--lv-text-secondary);
    line-height: 1.5;

    p {
      margin: 0;
    }
  }

  &__telegram {
    margin: 0;
  }

  &__telegram-link {
    appearance: none;
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    line-height: inherit;
    color: var(--lv-text-accent);
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      color: var(--lv-magenta-700);
    }

    &:disabled {
      opacity: .6;
      cursor: default;
    }
  }

  &__error {
    margin: 0;
    color: var(--lv-text-danger);
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  &__cta {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
  }
}
</style>
